module.exports = __webpack_public_path__ + "assets/icon-rating-star-component.643b1327.svg";